<div
  class="wrapper-home container-fluid px-0 mx-0 d-flex flex-column justify-content-evenly flex-grow-1 padding-top-wrapper"
  *transloco="let t"
>
  <div class="welcome m-5">
    <h1 class="text-white fw-bold fs-3">{{ t('home.welcome') }}</h1>
    <div>
      <h1 class="text-white fw-bold fs-3">{{ t('home.browseADSystem') }}</h1>
    </div>
  </div>
  <div class="h-auto d-block my-5">
    <app-navigation-card></app-navigation-card>
  </div>
</div>
